define('modules/editor/services/text_content/index',['require','exports','module','common/models/appstate','../../views/editors/text'],function (require, exports, module) {
  "use strict";
  var AppState = require("common/models/appstate"),
      TextEditorView = require("../../views/editors/text");

  module.exports = {
    editor: {},
    editText: function (text, callback) {

      var editorView = new TextEditorView({
        content: text
      });
      AppState.setPropsPopUpOpen(true);

      editorView.once("modal:save", function(content){
        callback(content);
        editorView.hide();
        AppState.setPropsPopUpOpen(false);
      });
    }
  };

});

